import Vue from 'vue';

export function changeActionStatus(state, { actionName, status }) {
  Vue.set(state.status, actionName, status);
}


export function resetActionStatus(state, { actionName }) {
  Vue.set(state.status, getActionStatusName(actionName), {});
}
export function setActionStatusPending(state, { actionName, ...data }) {
  Vue.set(state.status, getActionStatusName(actionName), { status: STATUS_PENDING, ...data });
}

export function setActionStatusSuccess(state, { actionName, ...data }) {
  Vue.set(state.status, getActionStatusName(actionName), { status: STATUS_SUCCESS, ...data });
}

export function setActionStatusError(state, { actionName, error, errorMessage, ...data }) {
  Vue.set(state.status, getActionStatusName(actionName), { status: STATUS_ERROR, error: errorMessage || errorStatusMessageHandler(error), ...data });
}

export const isLoading = (state) => (actionName) => {
  return state.status[getActionStatusName(actionName)]?.status === 'pending';
};

export const errorStatusMessageHandler = (error) => {
  let message = 'Operation failed: an error has occurred';
  if (error && error.data) {
    if (error.data.modelState && error.data.modelState[''][0]) {
      message = error.data.modelState[''][0];
    } else if (error.data.errors && Array.isArray(error.data.errors) && typeof error.data.errors[0] === 'string') {
      message = error.data.errors[0];
    } else if (error.data.errors && typeof error.data.errors === 'object') {
      // ASP.NET Core validation format: { errors: { fieldName: [messages] } }
      const firstKey = Object.keys(error.data.errors)[0];
      if (firstKey && error.data.errors[firstKey] && error.data.errors[firstKey][0]) {
        message = error.data.errors[firstKey][0];
      }
    } else if (error.data.failReason && error.data.failReason.errorMessage && error.data.failReason.errorMessage != '') {
      message = error.data.failReason.errorMessage;
    } else if (error.data.message && error.data.message != '') {
      message = error.data.message;
    } else if (error.data.title && error.data.title != '') {
      // ASP.NET Core validation format uses 'title' instead of 'message'
      message = error.data.title;
    } else if (error.data.error_description && error.data.error_description != '') {
      message = error.data.error_description;
    }
  }
  if (typeof message !== 'string') return 'Operation failed: an error has occurred';
  return message.charAt(0).toUpperCase() + message.slice(1);
};

export const getStatus = (state, actionName) => state.status[getActionStatusName(actionName)] || {};

export const getActionStatusName = (action) => action + '_Status';

export const CHANGE_ACTION_STATUS = 'changeActionStatus';
export const RESET_ACTION_STATUS = 'resetActionStatus';
export const SET_ACTION_STATUS_PENDING = 'setActionStatusPending';
export const SET_ACTION_STATUS_SUCCESS = 'setActionStatusSuccess';
export const SET_ACTION_STATUS_ERROR = 'setActionStatusError';
export const STATUS_PENDING = 'pending';
export const STATUS_ERROR = 'error';
export const STATUS_SUCCESS = 'success';